import React from 'react';
import { Link } from 'react-router-dom';
import './CoursePage.css';

const CoursesListPage = () => {
  const dummyCourses = [
    {
      id: 'vJtt6FQ6H8xaQGdFtHQs',
      title: 'English Grammar Course',
      description: 'Master the fundamentals of English grammar.',
      instructor: 'John Doe',
      category: 'Communication',
      price: 799,
      image: 'https://source.unsplash.com/300x200/?english,grammar',
    },
    {
      id: 'dummy2',
      title: 'Python for Beginners',
      description: 'Learn Python programming from scratch.',
      instructor: 'Jane Smith',
      category: 'Programming',
      price: 899,
      image: 'https://source.unsplash.com/300x200/?python,programming',
    },
    {
      id: 'dummy3',
      title: 'Digital Marketing Mastery',
      description: 'Boost your career with digital marketing skills.',
      instructor: 'Mike Johnson',
      category: 'Business',
      price: 666,
      image: 'https://source.unsplash.com/300x200/?marketing,digital',
    },
    {
      id: 'dummy4',
      title: 'Data Science Fundamentals',
      description: 'Learn the core concepts of data science.',
      instructor: 'Sarah Williams',
      category: 'Data Science',
      price: 799,
      image: 'https://source.unsplash.com/300x200/?data,science',
    },
    {
      id: 'dummy5',
      title: 'Web Development Bootcamp',
      description: 'Become a full-stack web developer.',
      instructor: 'David Brown',
      category: 'Web Development',
      price: 699,
      image: 'https://source.unsplash.com/300x200/?web,development',
    },
    {
      id: 'dummy6',
      title: 'Mobile App Development',
      description: 'Build iOS and Android apps from scratch.',
      instructor: 'Emily Chen',
      category: 'Mobile Development',
      price: 479,
      image: 'https://source.unsplash.com/300x200/?mobile,app',
    },
  ];

  return (
    <div className="courses-list-page">
      <div className="courses-hero">
        <h1>Expand Your Career Opportunities</h1>
        <p>Learn in-demand skills with our professional courses</p>
      </div>
      
      <div className="courses-filter">
        <div className="filter-buttons">
          <button className="filter-btn active">All</button>
          <button className="filter-btn">Programming</button>
          <button className="filter-btn">Business</button>
          <button className="filter-btn">Design</button>
          <button className="filter-btn">Marketing</button>
        </div>
        
        <div className="search-sort">
          <div className="search-box">
            <input type="text" placeholder="Search courses..." />
            <button>Search</button>
          </div>
          <select className="sort-select">
            <option>Most Popular</option>
            <option>Highest Rated</option>
            <option>Newest</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
          </select>
        </div>
      </div>
      
      <div className="courses-grid">
        {dummyCourses.map((course) => (
          <div key={course.id} className="course-card">
            <div className="course-image">
              <img src={course.image} alt={course.title} />
              <div className="course-overlay">
                <span className="preview-text">Preview this course</span>
              </div>
            </div>
            
            <div className="card-content">
              <h3>{course.title}</h3>
              <p className="course-description">{course.description}</p>
              <p className="instructor">By {course.instructor}</p>
              
              <div className="course-rating">
                <span className="rating-value">4.7</span>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
                <span className="rating-count">(1,234)</span>
              </div>
              
              <div className="course-meta">
                <span className="lecture-count">15 lectures • 5h 20m</span>
                <span className="level">All levels</span>
              </div>
              
              <div className="price-container">
                <span className="current-price">{course.price}</span>
                <span className="original-price">2000</span>
                <span className="discount-badge">Bestseller</span>
              </div>
            </div>
            
            <Link to={`/course/${course.id}`} className="enroll-btn">Enroll Now</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesListPage;